module.exports = __webpack_public_path__ + "img/student_6.fbef4e11.png";